export enum IbexaContentTypeIdentifier {
	vgsFrameBlock = 'vgs_frame_block',
	vgsExpandElement = 'vgs_expand_element',
	vgsLongformText = 'vgs_longform_text',
	vgsProduct = 'product',
	vgsResourceGuide = 'vgs_resource_guide',
	vgsSolution = 'vgs_solution',
	vgsSubjectContent = 'vgs_subject_content',
	vgsSubjectResource = 'vgs_subject_resource',
	vgsStepTask = 'vgs_task',
	vgsTaskFrontpage = 'vgs_task_frontpage',
	vgsTopicGuide = 'vgs_topic_guide',
	vgsTeacherGuide = 'vgs_teacher_guide',
	vgsTextImageElement = 'vgs_text_image_element',
	vgsThinkTextElement = 'vgs_think_text_element',
	vgsTopic = 'vgs_theme',
	vgsTopSectionElement = 'vgs_top_section_element',
	vgsExternalLink = 'vgs_external_link',
	vgsFlytTask = 'vgs_flyt_task',
	vgsFolder = 'folder',
	vgsCredits = 'vgs_credits',
	vgsConversation = 'vgs_conversation',
	vgsGlossCollection = 'vgs_gloss_collection',
	vgsGloss = 'vgs_word_with_translation_and_audio',
	vgsPresentation = 'vgs_presentation',
	vgsSentence = 'vgs_sentence_with_translation_and_audio',
	vgsSlideCoverImage = 'vgs_slide_cover',
	vgsSlideSideBySide = 'vgs_slide_side_by_side',
	vgsSlideTextOnly = 'vgs_slide_text_only',
	vgsSlideVideo = 'vgs_slide_video',
	vgsSubjectGuide = 'vgs_subject_guide',
	vgsVideo = 'vgs_video',
	vgsPronunciationBoxCollection = 'vgs_pronunciation_box_collection',
	vgsPronunciationBox = 'vgs_pronunciation_box',
	vgsFile = 'file'
}

export default IbexaContentTypeIdentifier
